__turbopack_context__.v({
  "active": "feuXEW_active",
  "default": "feuXEW_default",
  "icon": "feuXEW_icon",
  "inactive": "feuXEW_inactive",
  "md": "feuXEW_md",
  "primary": "feuXEW_primary",
  "primaryWithIcon": "feuXEW_primaryWithIcon",
  "root": "feuXEW_root",
  "secondary": "feuXEW_secondary",
  "value": "feuXEW_value",
});
